import React, { forwardRef } from "react";

import { ICaptionProps } from "./Caption1";
import { ITypographyProps, Typography } from "../Typography";

export const Caption2 = forwardRef<
  HTMLDivElement,
  ICaptionProps & Omit<ITypographyProps, keyof ICaptionProps | "variant">
>(({ weight = "regular", children, ...props }, ref) => {
  return (
    <Typography variant="Caption 2" weight={weight} ref={ref} {...props}>
      {children}
    </Typography>
  );
});

Caption2.displayName = "Caption2";
